module.exports = __webpack_public_path__ + "static/media/fill_60.e9fe1114.svg";